import { Button, Paper, Stack } from '@mui/material'
import { useEffect, useState } from 'react'
import { useStoreActions, useStoreState } from '../../../store/hooks'
import GameHistory from '../../Profile/components/GameHistory'
import StatsTable from '../../Profile/components/StatsTable'

enum STATS_TABS {
    STATS = 'stats',
    GAME_HISTORY = 'games history',
}

const STATS_CONTENT = {
    [STATS_TABS.STATS]: <StatsTable />,
    [STATS_TABS.GAME_HISTORY]: <GameHistory />,
}

export const Stats = () => {
    const settings = useStoreState((state) => state.gameView.settings)
    const initStats = useStoreActions((state) => state.profileView.initStats)

    const [tab, setTab] = useState(STATS_TABS.STATS)
    useEffect(() => {
        initStats()
    }, [settings.friendlyMode])

    return (
        <>
            <Stack direction="row" spacing={1} mb="-2px" px={1} zIndex={0}>
                {Object.values(STATS_TABS).map((item) => (
                    <Button tab size="large" onClick={() => setTab(item)} fullWidth selected={item === tab}>
                        {item}
                    </Button>
                ))}
            </Stack>

            <Paper sx={{ display: 'flex', flexGrow: 1, height: 'calc(100% - 48px)' }} variant="outlined">
                {STATS_CONTENT[tab]}
            </Paper>
        </>
    )
}
